import React, { useState, useEffect, useMemo, useCallback } from "react";
import Topbar from "../../components/Topbar/Topbar";
import {
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DateRange from "../../components/DateRange/DateRange";
import { Table } from "../../components/Table/Table";
import moment from "moment";
import { checkPermission } from "../redux/api/PermissionManager";
import { useLocation, useNavigate } from "react-router-dom";
import { edit_icon } from "../../assets/img";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { toast } from "react-toastify";
import {
  customFilterOption,
  formatOptionLabel,
} from "../../components/StaticData";

const customStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: "#F4F4F4",
    borderRadius: "8px",
    borderColor: "#ccc",
    boxShadow: "none",
    padding: "4px 8px",
  }),
  menu: (base) => ({
    ...base,
    maxHeight: 160,
    overflowY: "auto",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: 160, // scrolling height
    overflowY: "auto", // enable scroll
  }),
  option: (base, state) => ({
    ...base,
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: state.isFocused ? "#f0eaff" : "#fff",
    color: "#000",
    padding: "10px",
  }),
};

const TABS = {
  CHAT_AI: "Chat AI",
  BOOKING_AI: "Booking AI",
};

const READ_STATUS = {
  UNREAD: "UnRead",
  READ: "Read",
};

const RATING_OPTIONS = [
  { value: 1, label: "Good" },
  { value: 0, label: "Bad" },
];

const AiArea = () => {
  const navigate = useNavigate();
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const [isCount, setIsCount] = useState("");

  const [pagination, setPagination] = useState(
    paginationData?.[path]?.pagination ?? {
      UnRead: {},
      Read: {},
    },
  );
  const [list, setList] = useState({ UnRead: [], Read: [] });

  const [isActiveTab, setIsActiveTab] = useState(
    paginationData?.[path]?.isActiveTab ?? READ_STATUS.UNREAD,
  );
  const [selectedFilter, setSelectedFilter] = useState(
    paginationData?.[path]?.selectedFilter ?? {
      from: "",
      to: "",
    },
  );
  const [openRemark, setOpenRemark] = useState(false);
  const [remark, setRemark] = useState("");

  const handleFilter = (key, val) => {
    setSelectedFilter((prev) => ({ ...prev, [key]: val }));
  };

  const addToGlobal = (d = {}) => {
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], ...d },
    }));
  };

  const handleCloseRemark = () => {
    setOpenRemark(false);
    setRemark("");
  };

  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "s_no",
        Cell: ({ row }) => (
          <p>
            {(pagination?.[isActiveTab]?.current_page - 1) * 10 +
              (row.index + 1)}
          </p>
        ),
      },
      {
        Header: "User Name",
        accessor: "user_name",
        Cell: ({ value, row }) => (
          <p className="text-nowrap">
            {value || "-"}&nbsp;
            <span style={{ color: "#adadad", fontSize: 12 }}>
              ({row?.original?.user_code})
            </span>
          </p>
        ),
      },
      {
        Header: "Area",
        accessor: "extracted_message",
        Cell: ({ value, row }) => {
          return (
            <p className="text-truncate" style={{ maxWidth: 250 }}>
              {value?.area || "-"}
            </p>
          );
        },
      },
      {
        Header: "Message",
        accessor: "message",
        Cell: ({ value, row }) => (
          <p className="text-nowrap">{value || "-"}&nbsp;</p>
        ),
      },
      {
        Header: "Date",
        accessor: "created_at",
        Cell: ({ value }) => (
          <p className="text-nowrap">
            {value ? moment(value).format("DD/MM/YYYY hh:mm A") : "-"}
          </p>
        ),
      },
      {
        Header: "Comments",
        accessor: "admin_remarks",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-js">
              {isActiveTab === "UnRead" ? (
                <button
                  onClick={() => setOpenRemark(row.original)}
                  className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14"
                  style={{ background: "#9a36e69c" }}
                >
                  Remark
                </button>
              ) : (
                <p className="text-truncate" style={{ maxWidth: 250 }}>
                  {value || "-"}
                </p>
              )}
            </div>
          );
        },
      },
    ],
    [pagination[isActiveTab]],
  );

  //API Functions

  const getList = async (page = 1) => {
    const params = new URLSearchParams({
      status: isActiveTab === "UnRead" ? 1 : 2,
      page: page,
    });

    if (selectedFilter.to) {
      params.append("from_date", selectedFilter.from);
      params.append("to_date", selectedFilter.to);
    }

    const url = `${URLS.AI_AREA_LIST}?${params.toString()}`;
    let res = await get(url);
    if (res?.status === "success") {
      console.log("ASKKADKASKDKAS", res);
      setList((prev) => ({ ...prev, [isActiveTab]: res?.data }));
      addToGlobal({
        pagination: {
          ...[pagination],
          [isActiveTab]: {
            current_page: page,
            last_page: res?.total_pages,
            count: res?.count,
          },
        },
        isActiveTab,
        selectedFilter,
      });
      setPagination((prev) => ({
        ...prev,
        [isActiveTab]: {
          current_page: page,
          last_page: res?.total_pages,
          count: res?.count,
        },
      }));
      setIsCount(res?.count);
    }
  };

  const submitRemark = async (isSkip) => {
    let payload = {
      remark: isSkip ? "" : remark,
    };
    handleCloseRemark();
    let res = await put(`${URLS.AI_AREA_COMMENT}${openRemark?.id}/`, payload);
    if (res?.status === "success") {
      toast.success(res?.message);
      getList();
    }
  };

  useEffect(() => {
    getList();
  }, [isActiveTab]);

  useEffect(() => {
    if (selectedFilter.from && selectedFilter.to) getList();
  }, [selectedFilter.to]);

  return (
    <div>
      <Topbar header="AI Area" subHead="Area's without Properties" />
      <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total:{isCount}
      </h2>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 20,
        }}
      >
        <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
          {Object.values(READ_STATUS).map((status) => (
            <div
              key={status}
              role="button"
              tabIndex={0}
              style={{
                background: isActiveTab === status ? "#AE55F5" : "#78788029",
                textAlign: "center",
                padding: "10px 20px",
                borderRadius: 8,
                cursor: "pointer",
              }}
              onClick={() => setIsActiveTab(status)}
            >
              <p style={{ color: isActiveTab === status ? "#fff" : "#000" }}>
                {status}
              </p>
            </div>
          ))}
        </div>

        <div className="d-flex gap-2 ac-jb">
          <DateRange
            setFromDate={(from) => handleFilter("from", from)}
            setToDate={(to) => handleFilter("to", to)}
          />
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={(page) => {
          let pageCount = pagination?.[isActiveTab] ?? {};
          if (pageCount?.current_page < pageCount?.last_page) getList(page);
        }}
        pagecount={pagination?.[isActiveTab] ?? {}}
        data={list?.[isActiveTab] ?? []}
        show={true}
      />

      <Dialog
        open={Boolean(openRemark)}
        onClose={handleCloseRemark}
        fullWidth
        maxWidth="sm"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DialogTitle>Add Remark</DialogTitle>
          <IconButton onClick={handleCloseRemark} size="small" sx={{ mr: 1 }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        <DialogContent>
          <TextField
            autoFocus
            multiline
            minRows={4}
            fullWidth
            placeholder="Enter your remark..."
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => submitRemark("skip")}>Skip</Button>
          <Button
            onClick={() => submitRemark()}
            variant="contained"
            disabled={!remark.trim()}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AiArea;
